import { MapPin } from "lucide-react";

const areas = [
  "Sector 14", "Sector 15", "Sector 22", "Sector 23",
  "Sector 28", "Sector 29", "Sector 31", "Sector 33",
  "Sector 38", "Sector 40", "Sector 42", "Sector 43",
  "Sector 45", "Sector 46", "Sector 47", "Sector 48",
  "Sector 49", "Sector 50", "Sector 51", "Sector 52",
  "Sector 53", "Sector 54", "Sector 55", "Sector 56",
  "Sector 57", "Sector 58", "Sector 61", "Sector 62",
  "DLF Phase 1-5", "Golf Course Road", "Sohna Road",
  "MG Road", "Udyog Vihar", "Palam Vihar",
  "South City", "Nirvana Country", "Sushant Lok",
  "Malibu Town", "Ardee City", "Manesar",
];

export default function ServiceAreas() {
  return (
    <section data-testid="service-areas-section" className="py-20 md:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-sky font-medium text-sm uppercase tracking-[0.2em] mb-3">
              Coverage
            </p>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-navy mb-6">
              Serving All of Gurugram
            </h2>
            <p className="text-slate-600 text-base leading-relaxed mb-8">
              From DLF Phases to Sohna Road, from Golf Course Extension to Manesar — Tank Buddy covers every corner of Gurugram and surrounding areas.
            </p>

            <div className="flex flex-wrap gap-2">
              {areas.map((area) => (
                <span
                  key={area}
                  className="inline-flex items-center gap-1 bg-white border border-slate-200 text-slate-700 text-xs font-medium px-3 py-1.5 rounded-full hover:border-sky/50 hover:text-navy transition-colors"
                >
                  <MapPin className="w-3 h-3 text-sky" />
                  {area}
                </span>
              ))}
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden shadow-xl">
            <img
              src="https://images.pexels.com/photos/33230969/pexels-photo-33230969.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Modern apartments in Gurugram"
              loading="lazy"
              className="w-full h-80 md:h-[440px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/20 via-transparent to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
